window.addEventListener('DOMContentLoaded', () => {
  Modal.Effect.open();
  Modal.Effect.close();
}, false);

const Modal = Modal || {};

Modal.Effect = (() => {
  const thumbs     = document.getElementsByClassName('thumb');
  const regexp     = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const findText   = /sjisseki/i;
  let event        = null;
  const body       = document.body; 
  const modal      = document.getElementById('modal');
  const modalInner = document.getElementById('modal-inner');
  const closeBtn      = document.getElementById('closeBtn');

  if (window.navigator.userAgent.search(regexp) !== -1) {
    event = 'touchend';
  } else {
    event = 'click';
  }

  const open = () => {
    for (let i = 0, l = thumbs.length; i < l; i++) {
      thumbs[i].addEventListener(event, () => {        
        const img = document.createElement('img');

        img.src = thumbs[i].src.replace(findText, 'jisseki');
        img.id = 'img';
        img.classList.add('img-anim');
        modalInner.insertAdjacentHTML('afterbegin', img.outerHTML);
        modal.classList.add('block');
        body.classList.add('fixed');
      }, false);
    }
  };

  const close = () => {
    window.addEventListener(event, (e) => {
      if (e.target.classList.contains('close-btn')
        || e.target.classList.contains('modal')) {
        modal.classList.remove('block');
        body.classList.remove('fixed');
        document.getElementById('img').parentNode.removeChild(document.getElementById('img'));
      }
    }, false);
  };

  return {
    open: open,
    close: close
  };
})();